import { adminPaths } from 'routes/constants/adminPaths';
import { isAdminAuthenticated } from 'routes/guards/session';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

/**
 * Public admin routes (sign-in, OTP).
 * - Sign-in stays reachable while authenticated so a new admin can replace the session.
 * - OTP stays reachable after tokens are written (`v7_startTransition`) to avoid a login flash.
 */
const AdminPublicRoute = () => {
  const { pathname } = useLocation();
  const isCredentialEntryRoute =
    pathname === adminPaths.signIn || pathname === adminPaths.otpVerification;

  if (isAdminAuthenticated() && !isCredentialEntryRoute) {
    return <Navigate to={adminPaths.base} replace />;
  }

  return <Outlet />;
};

export default AdminPublicRoute;
